import React, { Component } from 'react';
import { Button, Form, Input, Modal, Select, Upload } from 'antd';
import { AlignRightOutlined, UploadOutlined } from '@ant-design/icons';
import cloneDeep from 'lodash/cloneDeep';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class EditBankForm extends Component {
    constructor() {
        super();

        this.state = {
            fileList: []
        };

        this.formRef = React.createRef();
    }

    handleSubmit = () => {
        this.formRef.current.validateFields()
            .then(values => {
                const formData = new FormData();

                formData.append('name', values.name);

                this.props.onSubmit(formData);
            });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();

        this.setState({ fileList: [] });
    }

    handleDidMount = (data = {}, subMode) => {
        const cloneData = cloneDeep(data);

        this.formRef.current.setFieldsValue(cloneData);

        this.setState({ editMode: !!cloneData.id });
    }

    render() {
        const { mainCats, onCancel, submitting, visible } = this.props;
        const { fileList, editMode, subMode } = this.state;


        return (
            <Modal
                title={`${editMode ? Resources.edit : Resources.add} ${Resources.banks} `}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={360}>
                <Form ref={this.formRef} layout="vertical">
                    <Form.Item name="name" label={Resources.title} rules={Rules.required}>
                        <Input type="text" prefix={<AlignRightOutlined />} />
                    </Form.Item>


                </Form>
            </Modal>
        );
    }
};

export default EditBankForm;